// Progressive sticky header: hides while scrolling down, returns after a 20px upward scroll.
class SStickyHeader extends HTMLElement {
  #controller = null;
  #lastY = 0;
  #upDistance = 0;
  #frame = 0;
  #host = this;

  connectedCallback() {
    this.#controller = new AbortController();
    this.#host = this.closest('header') ?? this;
    this.#lastY = window.scrollY;
    this.#update();
    window.addEventListener('scroll', () => {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => this.#update());
    }, { passive: true, signal: this.#controller.signal });
    // Keyboard users must always reach the header, so focus inside reveals it.
    this.#host.addEventListener('focusin', () => this.#host.removeAttribute('data-hidden'), { signal: this.#controller.signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #update() {
    const y = window.scrollY;
    const delta = y - this.#lastY;
    this.#host.toggleAttribute('data-scrolled', y > 8);
    if (y < 120) {
      this.#host.removeAttribute('data-hidden');
      this.#upDistance = 0;
    } else if (delta > 0) {
      this.#upDistance = 0;
      if (!this.#host.contains(document.activeElement)) this.#host.setAttribute('data-hidden', '');
    } else if (delta < 0) {
      this.#upDistance += -delta;
      if (this.#upDistance >= 20) this.#host.removeAttribute('data-hidden');
    }
    this.#lastY = y;
  }
}

if (!customElements.get('s-sticky-header')) customElements.define('s-sticky-header', SStickyHeader);
